export default __webpack_public_path__ + "static/media/gpride-back-pickup-map-obptcknr75tn1prdl0uuh00egk2x2n40qa4or947bk.581bcbc3.png";